// 数学优势
import React, { useContext } from 'react';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';

import classNames from 'classnames';
import { PC } from '@wukong/haomao';
import Title from '../Title';
import { MyContext } from '../../../../config/context-manager';
import styles from './style.module.scss';

export interface YesNoImgProps {
  type: boolean;
}

const YesNoImg = ({ type }: YesNoImgProps) => {
  return (
    <>
      {type ? (
        <Image src="/images/chinese-math-class/math/specialty/yes.png" width={50} height={50} alt="" />
      ) : (
        <Image src="/images/chinese-math-class/math/specialty/no.png" width={50} height={50} alt="" />
      )}
    </>
  );
};

const ChineseAbility = () => {
  const { t } = useTranslation(['mathSpecialty', 'chineseSpecialty']);
  const { locale } = useContext(MyContext);
  interface ItemProps {
    info: string;
    wukong: boolean;
    other: boolean;
    traditional: boolean;
  }
  const courseConfig: ItemProps[] = [
    {
      info: t('悟空优势-内容-1'),
      wukong: true,
      other: false,
      traditional: false,
    },
    {
      info: t('悟空优势-内容-2'),
      wukong: true,
      other: false,
      traditional: false,
    },
    {
      info: t('悟空优势-内容-3'),
      wukong: true,
      other: false,
      traditional: false,
    },
    {
      info: t('悟空优势-内容-4'),
      wukong: true,
      other: false,
      traditional: false,
    },
    {
      info: t('悟空优势-内容-5'),
      wukong: true,
      other: false,
      traditional: false,
    },
    {
      info: t('悟空优势-内容-6'),
      wukong: true,
      other: false,
      traditional: false,
    },
    {
      info: t('悟空优势-内容-7'),
      wukong: true,
      other: false,
      traditional: false,
    },
  ];

  return (
    <section
      className={classNames(styles.container, {
        [styles.localeEn]: locale === 'en',
      })}
    >
      <PC>
        <div>
          <Title>{t('悟空优势-标题')}</Title>
          <div className={styles.tableBox}>
            <table>
              <thead>
                <tr>
                  <th>&nbsp;</th>
                  <th>
                    <div
                      className={styles.title}
                      dangerouslySetInnerHTML={{ __html: t('悟空优势-标题-悟空国际数学思维课') }}
                    />
                  </th>
                  <th>
                    <div
                      className={styles.title}
                      dangerouslySetInnerHTML={{ __html: t('悟空优势-标题-其他在线平台') }}
                    />
                  </th>
                  <th>
                    <div
                      className={styles.title}
                      dangerouslySetInnerHTML={{ __html: t('悟空优势-标题-线下传统数学学校') }}
                    />
                  </th>
                </tr>
              </thead>
              <tbody>
                {courseConfig.map((item) => {
                  return (
                    <tr key={item.info}>
                      <td width={390}>
                        <div className={styles.info} dangerouslySetInnerHTML={{ __html: item.info }} />
                      </td>
                      <td width={279} className={styles.two}>
                        <div className={styles.picture}>
                          <YesNoImg type={item.wukong} />
                        </div>
                      </td>
                      <td width={200} className={styles.three}>
                        <div className={styles.picture}>
                          <YesNoImg type={item.other} />
                        </div>
                      </td>
                      <td width={320} className={styles.four}>
                        <div className={styles.picture}>
                          <YesNoImg type={item.traditional} />
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </PC>
    </section>
  );
};

export default ChineseAbility;
